export default "__VITE_ASSET__fbb6f2bd__"